// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"Modal_modal_wrapper__8L-3I"};